import type { ToolCallId } from "./types";

export type { ToolCallId } from "./types";

export function toolCallIdOf(part: { toolCallId: string }): ToolCallId {
  return part.toolCallId as ToolCallId;
}
